import { Card } from 'antd';
import { CardTitleWithIcon } from '@ohpen/enso-ui';
import { CrudFormCardProps } from '../interfaces';

export const CrudFormCard = ({ children, icon, title, extra, bodyScroll }: CrudFormCardProps) => {
  return (
    <Card
      key="firm-card"
      title={<CardTitleWithIcon icon={icon} title={title} />}
      variant="outlined"
      size="small"
      extra={extra}
      className={
        [bodyScroll ? 'enso-ui-card-body-scroll' : '', extra ? 'enso-ui-card-has-extra' : ''].filter(Boolean).join(' ') || undefined
      }
    >
      {children}
    </Card>
  );
};
